import { createAsyncThunk } from "@reduxjs/toolkit";
import { getClientList, getClienAlltList } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";

export const getClientData = createAsyncThunk("client/getClientList", async (para) => {
    try {
        const response = await getClientList(para);
        
        return response; // Return the response data if successful
    } catch (error) {
        toast.error(error?.errorData?.message)
        return error;
    }
});

export const getAllClientList = createAsyncThunk("client/getAllClientList", async (id) => {
    try {
        const response = await getClienAlltList(id);
        
        return response; // Return the response data if successful
    } catch (error) {
        toast.error(error?.errorData?.message)
        return error;
    }
});
